/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Premium_Content_UnlockedInputs */

const en_premium_content_unlocked = /** @type {(inputs: Premium_Content_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium Content Unlocked`)
};

const id_premium_content_unlocked = /** @type {(inputs: Premium_Content_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konten Premium Terbuka`)
};

/** @type {(inputs: Premium_Content_UnlockedInputs) => LocalizedString} */
const es_premium_content_unlocked = en_premium_content_unlocked;

/** @type {(inputs: Premium_Content_UnlockedInputs) => LocalizedString} */
const fr_premium_content_unlocked = en_premium_content_unlocked;

/** @type {(inputs: Premium_Content_UnlockedInputs) => LocalizedString} */
const de_premium_content_unlocked = en_premium_content_unlocked;

/** @type {(inputs: Premium_Content_UnlockedInputs) => LocalizedString} */
const ja_premium_content_unlocked = en_premium_content_unlocked;

/** @type {(inputs: Premium_Content_UnlockedInputs) => LocalizedString} */
const zh_premium_content_unlocked = en_premium_content_unlocked;

/** @type {(inputs: Premium_Content_UnlockedInputs) => LocalizedString} */
const ar_premium_content_unlocked = en_premium_content_unlocked;

/** @type {(inputs: Premium_Content_UnlockedInputs) => LocalizedString} */
const it_premium_content_unlocked = en_premium_content_unlocked;

/** @type {(inputs: Premium_Content_UnlockedInputs) => LocalizedString} */
const ru_premium_content_unlocked = en_premium_content_unlocked;

/** @type {(inputs: Premium_Content_UnlockedInputs) => LocalizedString} */
const pt_premium_content_unlocked = en_premium_content_unlocked;

/** @type {(inputs: Premium_Content_UnlockedInputs) => LocalizedString} */
const ko_premium_content_unlocked = en_premium_content_unlocked;

/**
* | output |
* | --- |
* | "Premium Content Unlocked" |
*
* @param {Premium_Content_UnlockedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const premium_content_unlocked = /** @type {((inputs?: Premium_Content_UnlockedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Premium_Content_UnlockedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_premium_content_unlocked(inputs)
	if (locale === "es") return es_premium_content_unlocked(inputs)
	if (locale === "fr") return fr_premium_content_unlocked(inputs)
	if (locale === "de") return de_premium_content_unlocked(inputs)
	if (locale === "ja") return ja_premium_content_unlocked(inputs)
	if (locale === "zh") return zh_premium_content_unlocked(inputs)
	if (locale === "ar") return ar_premium_content_unlocked(inputs)
	if (locale === "id") return id_premium_content_unlocked(inputs)
	if (locale === "it") return it_premium_content_unlocked(inputs)
	if (locale === "ru") return ru_premium_content_unlocked(inputs)
	if (locale === "pt") return pt_premium_content_unlocked(inputs)
	return ko_premium_content_unlocked(inputs)
});